import React, { Component } from 'react';

import cinemas from './cinemas';

import { getCookie } from '../../helpers/cookie';

export default class TownChoices extends Component {
  state = {
    townIsOpen: this.props.townIsOpen,
    selectedCity: null,
    listCityIsOpen: false, // state for mobile
    cityAlert: false,
  };

  componentDidMount() {
    const citiesObj = {
      1: 'Челябинск',
      2: 'Магнитогорск',
      3: 'Самара',
      4: 'Уфа',
      5: 'Нижний Тагил',
      6: 'Москва',
      7: 'Екатеринбург',
      8: 'Пермь',
    };

    const cityId = getCookie('currentCity');
    const selectedCity = this.props.cinema || citiesObj[cityId] || 'Челябинск';
    this.setState({ selectedCity });
  }

  prepareCinemaItems = classes => {
    const { selectedCity } = this.state;
    const classesItems = classes.items;
    const classesBody = classes.body;

    return cinemas
      .filter(cinema => cinema.city === selectedCity)
      .map(cinema => {
        if (cinema.short_name === selectedCity)
          classesItems.push('town-item--active ');

        return (
          <a
            href={cinema.link}
            className={classesItems.join(' ')}
            key={cinema.short_name}
          >
            <span className={classesBody.join(' ')}>
              <span className={classes.image.join(' ')}>
                <img
                  src={cinema.img}
                  alt={cinema.short_name}
                  title={cinema.short_name}
                />
              </span>
              <span className={classes.capture.join(' ')}>
                {cinema.address}
              </span>
            </span>
          </a>
        );
      });
  };

  changeCity = e => {
    this.setState({
      selectedCity: e.currentTarget.textContent,
      listCityIsOpen: false,
      cityAlert: true,
    });
  };

  prepareListCities = (classes, classesIsActive) => {
    const listCities = [
      'Екатеринбург',
      'Магнитогорск',
      'Москва',
      'Нижний Тагил',
      'Самара',
      'Уфа',
      'Челябинск',
      'Пермь',
    ];

    const { selectedCity } = this.state;

    return listCities.map(item => {
      return (
        <button
          type="button"
          className={`${classes.join(' ')} ${
            item === selectedCity ? classesIsActive.join(' ') : ''
          }`}
          onClick={this.changeCity}
          key={item}
        >
          {item}
          <svg
            width="5"
            height="8"
            viewBox="0 0 5 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.40007 0.22601C1.24754 0.0799851 1.04423 -0.00105152 0.833073 1.03044e-05C0.609043 0.00343397 0.39552 0.0955885 0.239354 0.256254C0.0831875 0.416919 -0.00286652 0.632973 7.29013e-05 0.85701C-0.000139758 0.975049 0.0238928 1.09187 0.070681 1.20024C0.117469 1.30861 0.186016 1.40622 0.272073 1.48701L2.93307 4.00001L0.270073 6.51101C0.184036 6.59213 0.115654 6.69013 0.0691974 6.79887C0.0227412 6.90761 -0.00079043 7.02476 7.29013e-05 7.14301C-0.00286652 7.36705 0.0831875 7.5831 0.239354 7.74377C0.39552 7.90443 0.609043 7.99659 0.833073 8.00001C1.04431 8.00049 1.24753 7.91913 1.40007 7.77301L4.73007 4.63201C4.81538 4.55033 4.88326 4.45223 4.92964 4.34361C4.97602 4.23499 4.99993 4.11811 4.99993 4.00001C4.99993 3.88191 4.97602 3.76503 4.92964 3.65641C4.88326 3.54779 4.81538 3.44969 4.73007 3.36801L1.40007 0.22601Z"
              fill="#CDCDCD"
            />
          </svg>
        </button>
      );
    });
  };

  render() {
    const { townIsOpen, listCityIsOpen, selectedCity, cityAlert } = this.state;
    const { position } = this.props;

    const classes = ['town'];
    if (townIsOpen) classes.push('town--open');
    if (listCityIsOpen) classes.push('town--list');

    const classesTownContainer = ['town-popup'];
    const classesTownList = ['town-popup__list'];
    const classesTownItem = ['town-popup__name-city'];
    const classesIsActive = ['is-active'];
    const classesCinemas = ['town-picker__list'];
    const classesCinemasItems = {
      items: ['town-item'],
      body: ['town-item__body'],
      image: ['town-item__pic'],
      capture: ['town-item__capture'],
    };

    if (position === 'static' || position === 'popup') {
      classes.push('town-static-back');
      classesTownContainer.push('town-popup--static lp-town-choose');
      classesTownList.push('lp-town-cities');
      classesTownItem.push('lp-city-item');
      classesIsActive.push('lp-city-item--active');
      classesCinemas.push('lp-town-cinemas');
      classesCinemasItems.items.push('lp-cinema-item');
      classesCinemasItems.body.push('lp-cinema-item__body');
      classesCinemasItems.image.push('lp-cinema-item__pic');
      classesCinemasItems.capture.push('lp-cinema-item__capture');
    }

    if (position === 'popup') {
      classesTownContainer.push('town-popup--popup lp-town-choose');
      classes.push('town-static-back');
    }

    if (position === 'header') {
      classesTownContainer.push('town-popup--header');
    }

    return (
      <div className={classes.join(' ')}>
        <div className={classesTownContainer.join(' ')}>
          {position === 'header' && (
            <button
              className="town-popup__close"
              type="button"
              onClick={() => {
                this.setState({
                  townIsOpen: false,
                  selectedCity: this.props.cinema.city,
                  cityAlert: false,
                });
                this.props.setStateChild(false, selectedCity, false);
              }}
            >
              <svg viewBox="0 0 18 18" width="18" height="18">
                <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"></path>
              </svg>
            </button>
          )}
          {position === 'popup' && (
            <div className="container-close_btn">
              <button
                className="close_btn"
                onClick={() => $.magnificPopup.close()}
              >
                <div className="border_btn">
                  <svg viewBox="0 0 18 18" width="18" height="18">
                    <path
                      d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"
                      fill="#fff"
                    ></path>
                  </svg>
                </div>
              </button>
            </div>
          )}

          <div className="town-popup__head">
            {position === 'header' && (
              <button
                type="button"
                className="town-popup__back"
                onClick={() => {
                  this.setState({
                    townIsOpen: false,
                    selectedCity: this.props.cinema.city,
                    cityAlert: false,
                  });
                  this.props.setStateChild(false, selectedCity, false);
                }}
              >
                Назад
              </button>
            )}

            <button
              type="button"
              className="town-popup__choice"
              onClick={() => this.setState({ listCityIsOpen: true })}
            >
              {selectedCity}
            </button>
          </div>

          <div className="town-popup__content">
            <div className={classesTownList.join(' ')}>
              <button
                type="button"
                className="town-popup__list-close"
                onClick={() => this.setState({ listCityIsOpen: false })}
              >
                <svg
                  width="28"
                  height="8"
                  viewBox="0 0 28 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27.2011 2.23733C27.7104 1.9959 27.9966 1.67398 28 1.33852C27.9887 0.979773 27.6664 0.637741 27.104 0.387584C26.5416 0.137428 25.785 -0.000395333 25.0004 0.00439258C24.5876 0.0039593 24.1789 0.0422945 23.7997 0.117028C23.4205 0.191761 23.0789 0.301303 22.7961 0.438861L13.9916 4.69732L5.20205 0.434589C4.9197 0.296974 4.57848 0.187393 4.19958 0.112651C3.82067 0.0379085 3.41217 -0.000399785 2.99952 0.000119601C2.21501 -0.00466838 1.45845 0.133168 0.896017 0.383324C0.333588 0.633481 0.0113086 0.975499 -5.8322e-08 1.33425C0.00320809 1.6694 0.287861 1.99118 0.795137 2.23307L11.7947 7.56787C12.0804 7.70447 12.4238 7.81317 12.8039 7.88744C13.184 7.96171 13.5931 8 14.0065 8C14.4199 8 14.829 7.96171 15.2092 7.88744C15.5893 7.81317 15.9326 7.70447 16.2184 7.56787L27.2011 2.23733Z"
                    fill="#D9D9D9"
                  />
                </svg>
              </button>
              {position === 'header' && (
                <p className="town-popup__title">
                  {listCityIsOpen === true ? 'Выберите город' : 'Город'}
                </p>
              )}
              {this.prepareListCities(classesTownItem, classesIsActive)}
            </div>

            <div className={classesCinemas.join(' ')}>
              {position === 'header' && (
                <p className="town-popup__title">Кинотеатр</p>
              )}
              {this.prepareCinemaItems(classesCinemasItems)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
